import { useEffect, useState } from 'react';
import {
  DashBoardLeft,
  BoxHeaderLeft,
  TitleLeft,
  DescriptionLeft,
} from '../../DashboardClientesStyled';
import BarChartComponent from '../../../../../../components/BarChart/BarChartComponent';
import { porEstadoMensualInicio } from '../../../../../../api/Clientes';
import { useAuth } from '../../../../../../context/AuthContext';

const footerLabel = [
  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
];

const Left = () => {
  const [chartData, setChartData] = useState([]);
  const { token } = useAuth();
  const { clienteId } = token;


  useEffect(() => {
    const fetchMuestrasConteo = async () => {
      try {
        const year = new Date().getFullYear();
        const fechaInicio = `${year}-01-01T00:00:00Z`;
        const fechaFin = `${year}-12-31T23:59:59Z`;

        const res = await porEstadoMensualInicio({
          fechaInicio,
          fechaFin,
          clienteId,
        });

        const cleanText = (str) =>
          str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();


        const estadoPorMes = {};

        res.data.forEach((item) => {
          const [_, month] = item.yearMonth.split('-');
          const monthIndex = parseInt(month, 10) - 1;

          const estado = cleanText(item.estadoFinalDesc);
          const color = item.color_efm;

          if (!estadoPorMes[estado]) {
            estadoPorMes[estado] = {
              data: Array(12).fill(0),
              color,
              label: item.estadoFinalDesc,
            };
          }

          estadoPorMes[estado].data[monthIndex] += item.cantidadMuestras || 0;
        });


        const chartDataList = Object.values(estadoPorMes);

        setChartData(chartDataList);
      } catch (error) {
        console.error(error);
      }
    };

    fetchMuestrasConteo();
  }, []);

  return (
    <DashBoardLeft>
      <BoxHeaderLeft>
        <TitleLeft>Cantidad Total de Muestras por Estado en el Año en Curso</TitleLeft>
        <DescriptionLeft>
          Aquí podrá consultar los totales mensuales de muestras por estado de toda la Empresa,
          para consultar otros gráficos presione la opción <span style={{ fontWeight: "bold" }}>“Reportes”</span> que se encuentra en la cabecera
        </DescriptionLeft>
      </BoxHeaderLeft>

      <BarChartComponent
        series={chartData}
        width={1000}
        height={500}
        grid={{ horizontal: true }}
        footerLabel={footerLabel}

      />
    </DashBoardLeft>
  );
};

export default Left;

